import { createFileRoute } from '@tanstack/react-router'
import WebhooksGuard from 'Administration/components/system/webhooks/WebhooksGuard'

export const Route = createFileRoute('/administration/integrations/_webhooks')({
    component: WebhooksGuard,
})
